import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const KnowledgeBaseIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "KnowledgeBase",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M28.47 8c-.27-.86-.86-1.59-1.63-2.04a7.6 7.6 0 0 0-4.35-1.44c-2.36.15-4.63 1.01-6.48 2.48l-.15-.19a9.54 9.54 0 0 0-6.09-2.29c-1.76 0-3.49.5-4.98 1.44-.72.48-1.21 1.24-1.36 2.09-1.16.29-1.41.99-1.41 2.61v13.11a2.98 2.98 0 0 0 3.17 2.75h8.85c.29.6.9.98 1.56.98h.85c.67 0 1.27-.37 1.56-.98h8.85c1.63.1 3.04-1.12 3.16-2.75V10.66c0-1.67-.24-2.38-1.53-2.65ZM6.8 23.25c-2.23.72-2.31.53-2.31-1.74V9.12a1.9 1.9 0 0 1 1.06-1.81c3.78-2.47 7.96-.67 9.72.79v15.87l-.17-.07c-2.64-1.07-5.09-1.7-8.29-.66Zm18.37 0c-2.98-1.41-6.75 0-8.24.66-.08.04-.17.07-.26.09V8.13c1.56-1.17 5.25-3.61 9.68-.83.71.31 1.16 1.03 1.12 1.81v12.91c.02 1.72 0 2.31-2.28 1.24Z"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M30.71 27.71c-.38 0-.74-.19-.95-.51-.08-.11-2.05-2.92-6.48-2.92s-6.4 2.81-6.49 2.93c-.21.31-.57.53-.95.5-.38 0-.74-.19-.95-.51-.08-.11-2.04-2.92-6.47-2.92s-6.4 2.81-6.48 2.93c-.28.41-.81.6-1.28.45-.48-.15-.81-.59-.81-1.09V9.15c0-.24.08-.47.22-.67.11-.15 2.68-3.62 8.35-3.62.61 0 1.21.04 1.79.12 3.87.54 6.78 3.94 6.78 7.92v6.81a1.14 1.14 0 1 1-2.28 0V12.9c0-2.84-2.07-5.27-4.81-5.66-.48-.07-.97-.1-1.48-.1-3.67 0-5.65 1.75-6.28 2.42V23.9c1.37-.96 3.44-1.91 6.29-1.91 3.8 0 6.21 1.68 7.42 2.85 1.22-1.17 3.63-2.85 7.43-2.85 2.85 0 4.91.94 6.28 1.91V9.56c-.63-.67-2.62-2.42-6.28-2.42-1.29 0-2.49.22-3.58.65-.59.23-1.25-.05-1.48-.64s.05-1.25.64-1.48c1.35-.54 2.84-.81 4.42-.81 5.66 0 8.24 3.47 8.35 3.62.14.19.22.43.22.67v17.42a1.137 1.137 0 0 1-1.14 1.14"
      })
    })
  }));
};
KnowledgeBaseIcon.displayName = 'KnowledgeBaseIcon';